import { Component } from '@angular/core';

@Component({
  selector: 'mom-points-progress-skeleton',
  templateUrl: 'points-progress-skeleton.component.html',
  styleUrls: ['./points-progress-skeleton.component.scss']
})
export class PointsProgressSkeletonComponent {}
